import axios from "axios";
import { baseUrl } from "./urls";

const instance = axios.create({
  baseURL: baseUrl,
});

export default instance;